import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import * as s from "./styles";
import { TipProps } from "./types";

// A highlighted note inside a tour step's content, put after the step's text.
export const Tip: FC<TipProps> = ({ children }: TipProps) => (
  <s.Tip>
    <s.TipIcon>
      <LightbulbOutlinedIcon fontSize={"small"} />
    </s.TipIcon>
    <Typography variant={"body2"} component={"div"}>
      {children}
    </Typography>
  </s.Tip>
);
